import {HTTP} from '@/router/http';
import Vue from 'vue'
import axios from 'axios'
const CancelToken = axios.CancelToken
let cancel


// initial state
const state = {
	projects: [],
	invoices: [],
	monitor_invoices: [],
	institutions: []
}

// getters
const getters = {
	projects: state => state.projects,
	invoices: state => state.invoices,
	monitor_invoices: state => state.monitor_invoices,
	institutions: state => state.institutions
}

// actions
const actions = {
	getInstitutions ({ commit,state }) {
		if (state.institutions.length === 0) {
			HTTP.get('/institutions').then(res => {
				commit("SET_INSTITUTIONS",res.data);
			})			
		}
	},
	
	getProjects ({ commit },params) {
		if (cancel) cancel()
		return new Promise ((resolve, reject) => {
			HTTP.get('/projects',{
				cancelToken: new CancelToken(function executor (c) {
					cancel = c
				}),
				params:params
			}).then(res => {
				commit('SET_PROJECTS', res.data)
				resolve(res.data)
			}).catch(err => reject(err));			
		})
	},
	createProject ({ commit,},params) {
		HTTP.post('/projects',params).then(res => {
			commit('ADD_PROJECTS', res.data.project)
			if (params.project.pi_id === 'newPI') {
				commit("ADD_PI",res.data.pi);
			}
			else {
				commit("UPDATE_PI",res.data.pi)
			}
		});
	},
	updateProject ({ commit,},params) {
		HTTP.put('/projects',params).then(res => {
			commit('UPDATE_PROJECT', res.data.project)
			commit('UPDATE_PI', res.data.pi)
		});
	},
	getInvoices ({ commit }, params) {
		if (cancel) cancel()
		HTTP.get('/invoices',{
			cancelToken: new CancelToken(function executor (c) {
				cancel = c
			}),
			params: params
		}).then(res => {
			if (params.year !== undefined) {
				commit("SET_MONITOR_INVOICES",res.data)								
			}
			else {
				commit("SET_INVOICES",res.data)				
			}
		})
	},
	setInvoiceStatus ({ commit }, params) {
		return new Promise ((resolve, reject) => {
			HTTP.put('/invoices/'+params.invoice_id,{status: params.status}).then(res => {
				commit("SET_INVOICE_STATUS",res.data)
				resolve(res.data.status)
			}).catch(err => {
				reject(err)
			})
		})
	},
	deleteInvoice ({ commit }, invoice) {
		return new Promise ((resolve, reject) => {
			HTTP.delete('/invoices/'+invoice.invoice_id).then(() => {
				commit("DELETE_INVOICE",invoice.invoice_id)
				resolve(true)
			}).catch(err => {
				reject(err)
			})
		})
	},
	createInvoices ({ commit }, params) {
		return HTTP.post('/invoices',{params: params}).then(res => {
			commit("SET_INVOICES",res.data)
			return true
		})
	},
	checkEditableDuration (ctx, params) {
		return new Promise ((resolve, reject) => {
			HTTP.post('/check_edit_duration',params).then(res => {
				resolve(res.data)
			}).catch(err => {
				reject(err)
			})
		})
	},	
	editMonthlyDuration ({ commit }, params) {
		return new Promise ((resolve, reject) => {
			HTTP.post('/edit_monthly_duration',params).then(res => {
				commit("UPDATE_PROJECT_TASKS",res.data)
				resolve(res.data)
			}).catch(err => {
				reject(err)
			})
		})
	},
	setInvoicePrice ({ commit }, params) {
		return new Promise ((resolve, reject) => {
			HTTP.patch("invoice/"+params.invoiceId,{manual_price: params.manualPrice}).then(res => {
				resolve(res.data)
				commit("PATCH_INVOICE_PRICE",params)
			}).catch(err => reject(err))
		})
			
	}
}

// mutations
const mutations = {
	SET_PROJECTS (state, projects) {
		state.projects = _.map(projects, p => {p.is_selected = false; return p})
	},
	SET_INSTITUTIONS (state,institutions) {
		state.institutions = institutions
	},
	ADD_PROJECTS (state, new_project) {
		state.projects.push(new_project)
	},
	UPDATE_PROJECT (state, project) {
		var pidx = _.findIndex(state.projects,function(p){return p.project_id === project.project_id;});
		if (pidx>-1){
			Vue.set(state.projects, pidx, project);
		}
	},
	SET_INVOICES (state, invoices) {
		state.invoices = invoices
	},
	SET_MONITOR_INVOICES (state, invoices) {
		state.monitor_invoices = invoices
	},
	SET_INVOICE_STATUS (state, invoice) {
		let idx = _.findIndex(state.monitor_invoices, i => {
			return i.invoice_id === invoice.invoice_id
		})
		if (idx > -1) {
			state.monitor_invoices[idx].status = invoice.status
		}
	},
	UPDATE_PROJECT_TASKS (state, projects) {
		_.forEach(projects, (tasks,project_id) => {
			let idx = _.findIndex(state.projects, p => +p.project_id === +project_id)
			if (idx > -1) {
				Vue.set(state.projects[idx],'tasks',tasks)
			}
		})
	},
	DELETE_INVOICE (state, invoice_id) {
		_.forEach(state.invoices, (invoice,idx) => {
			let idx2 = _.findIndex(invoice.invoices, i => i.invoice_id === invoice_id)
			if (idx2 > -1){
				state.invoices[idx].invoices.splice(idx2,1)
			} 
		})
	},
	PATCH_INVOICE_PRICE (state, params) {
		const idx = _.findIndex(state.monitor_invoices, i => i.invoice_id === params.invoiceId)
		if (idx > -1) {
			state.monitor_invoices[idx].price = +params.manualPrice
		}
		_.forEach(state.invoices, (invoice,idx) => {
			let idx2 = _.findIndex(invoice.invoices, i => i.invoice_id === params.invoiceId)
			if (idx2 > -1){
				state.invoices[idx].invoices[idx2].price = params.manualPrice
			} 
		})
	}
	
}

export default {
	state,
	getters,
	actions,
	mutations
}